import { systemConfig } from '@/config/system.config';

async function fetchJson(url: string): Promise<unknown> {
  const res = await fetch(url, { method: 'GET' });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  return await res.json();
}

const tenantConfigCache = new Map<string, Promise<{ config: unknown; planningConfig: unknown }>>();

export function clearTenantConfigCache(): void {
  tenantConfigCache.clear();
}

export async function fetchTenantConfigs(
  tenantId: string
): Promise<{ config: unknown; planningConfig: unknown }> {
  const cacheKey = tenantId.toLowerCase();
  let cached = tenantConfigCache.get(cacheKey);
  if (!cached) {
    cached = Promise.all([
      fetchJson(systemConfig.getConfigUrl(tenantId)),
      fetchJson(systemConfig.getPlanningConfigUrl(tenantId)),
    ]).then(([config, planningConfig]) => ({ config, planningConfig }));
    tenantConfigCache.set(cacheKey, cached);
    cached.catch(() => {
      tenantConfigCache.delete(cacheKey);
    });
  }
  return cached;
}
